import axios from 'axios';
import authHeader from "./auth-header";
// const BASE_URL = 'https://apicareer.alkaloid.com.mk/data/rest/';
// const BASE_AUTH_URL = 'https://apicareer.alkaloid.com.mk/api/auth/';
// const BASE_REPORT_URL = 'https://apicareer.alkaloid.com.mk/reports/';

const BASE_URL = 'https://api.kam-kariera.mk/data/rest/';
const BASE_AUTH_URL = 'https://api.kam-kariera.mk/api/auth/';
const BASE_REPORT_URL = 'https://api.kam-kariera.mk/reports/';

// const BASE_URL = 'http://localhost:3000/data/rest/';
// const BASE_AUTH_URL = 'http://localhost:3000/api/auth/';
// const BASE_REPORT_URL = 'http://localhost:3000/reports/';


/**
 * Makes a request to the backend with axios to get a resource.
 *
 * @param {string} resource the type of the resource we want to fetch.
 * @returns the fetched resources or an exception
 */

export const getResource = (resource) => {
    return axios
        .get(`${BASE_URL}${resource}`, {headers: authHeader()})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            console.error(exception);
            // console.log(exception.response.data.message)
            throw exception;
        });
};
export const getByIdResource = (resource, id) => {
    return axios
        .get(`${BASE_URL}${resource}/${id}`, {headers: authHeader()})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            console.error(exception);
            // console.log(exception.response.data.message)
            throw exception;
        });
};

export const getByEducationGroupResource = (resource, educationGroup) => {
    return axios
        .get(`${BASE_URL}${resource}/${educationGroup}`, {  params: {
                educationGroup: educationGroup,
            }, headers: authHeader()})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            console.error(exception);
            // console.log(exception.response.data.message)
            throw exception;
        });
};
/**
 * Makes a request to update a backend resource.
 *
 * @param {string} resource the type of the resource we want to update.
 * @param {object} data the data we post to the backend.
 *
 * @returns the result or an exception.
 */
export const updateResource = (resource, data) => {
    console.log('vo update resource datata')
    console.log(data);
    return axios
        .post(`${BASE_URL}${resource}`, data, {headers: authHeader()})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            // console.log(exception.response.data.message);
            throw exception;
        });
};
export const uploadFileResource = (resource, data) => {
    return axios
        .post(`${BASE_URL}${resource}`, data, {headers: authHeader(), 'Content-Type': "multipart/form-data"})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            // console.log(exception.response.data.message);
            throw exception;
        });
};
export const getFilteredResource = (resource, filtersDto) => {
    return axios
        .post(`${BASE_URL}${resource}`, filtersDto, {headers: authHeader()})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            // console.log(exception.response.data.message);
            throw exception;
        });
};
export const updateAuthResource = (resource, data) => {
    console.log('vo updateAuthResource')
    console.log(data);
    return axios
        .post(`${BASE_AUTH_URL}${resource}`, data, {headers: authHeader()})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            // console.log(exception.response.data.message);
            throw exception;
        });
};
export const authenticate = (resource, data) => {
    console.log('vo authenticate');
    console.log(data);
    return axios
        .post(`${BASE_AUTH_URL}${resource}`, data, {headers: authHeader()})
        .then((response) => {
            // console.log('response in then vo authenticate', response);
            return response;
        })
        .catch((exception) => {
            // console.log(exception.response.data.message);
            throw exception;
        });
};

export const deleteResource = (resource, data) => {
    console.log('vo update resource datata')
    console.log(data);
    return axios
        .delete(`${BASE_URL}${resource}/${data.id}`, {headers: authHeader()})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            // console.log(exception.response.data.message);
            throw exception;
        });
};


export const downloadMinioFile = (resource, id) => {
    return axios
        .get(`${BASE_URL}${resource}/${id}`, {headers: authHeader(), responseType: 'blob'})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            console.error(exception);
            // console.log(exception.response.data.message)
            throw exception;
        });
};


export const getReportResource = (resource) => {
    return axios
        .get(`${BASE_REPORT_URL}${resource}`, {headers: authHeader(), responseType: 'blob'})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            // console.error(exception);
            // console.log(exception.response.data.message)
            throw exception;
        });
};

export const changePasswordResource = (resource, data) => {
    console.log('vo updateAuthResource')
    console.log(data);
    return axios
        .post(`${BASE_AUTH_URL}${resource}`, {'password': data.password, 'oldPassword': data.oldPassword},
            {headers: authHeader()})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            // console.log(exception.response.data.message);
            throw exception;
        });
};

export const getAuthResource = (resource) => {
    return axios
        .get(`${BASE_AUTH_URL}${resource}`, {headers: authHeader()})
        .then((response) => {
            // console.log('response in then ', response);
            return response;
        })
        .catch((exception) => {
            console.error(exception);
            // console.log(exception.response.data.message)
            throw exception;
        });
};